import React, { useState } from "react";

export default function Modal() {

    const [modal, setModal] = useState(true)

    const toggleModal = () => {
        setModal(!modal)
    }

    return (
        <>
            <div style={{ textAlign: 'center' }} data-aos="flip-up">
                <h4 >ASSINE NOSSA NEWSLETTER GRATUITAMENTE.</h4>
                <button onClick={toggleModal} className='btn-success'>
                    INSCREVA-SE
                </button>
            </div>


            {modal && (
                <div className="back" data-aos="flip-up">
                    <div id="divf" >
                        <h3 style={{ textAlign: 'center', paddingTop: '10px' }} >ASSINE NOSSA NEWSLETTER GRATUITAMENTE.</h3>
                        <p style={{ textAlign: 'center' }} >Assine nosso newsletter para receber dicas, curiosidades, desafios e muito mais.</p>
                        <form className="form">
                            <input style={{ marginBottom: '15px' }} type='text' name='Name' placeholder="NOME" />
                            <input type='text' name='email' placeholder="EMAIL" />
                            <input style={{ marginTop: '15px' }} type="submit" value="INSCREVA-SE"></input>
                        </form>
                        <button className="close" onClick={toggleModal}>
                            X
                        </button>
                    </div>
                </div>
            )}
     
        </>
    )
}

